import Axios from "../../../lib/Axios";

export const getActivePhoneOtpList = async () => {
  const result = await Axios.get(
    "business/verification/admin/phone-otp/active"
  );
  const payload = result?.data?.result || {};
  const items = Array.isArray(payload.items) ? payload.items : [];
  const count = Number.isFinite(payload.count) ? payload.count : items.length;

  return {
    data: items,
    totalRecords: count,
  };
};

export const getPendingCinPanList = async () => {
  const result = await Axios.get("business/verification/admin/cin-pan/pending");
  const payload = result?.data?.result || {};
  const items = Array.isArray(payload.items) ? payload.items : [];
  const count = Number.isFinite(payload.count) ? payload.count : items.length;

  return {
    data: items,
    totalRecords: count,
  };
};

export const reviewCinPan = async (input = {}) => {
  const spaceId = typeof input.spaceId === "string" ? input.spaceId.trim() : "";
  const action = typeof input.action === "string" ? input.action.trim() : "";
  const rejectionReason =
    typeof input.rejectionReason === "string"
      ? input.rejectionReason.trim()
      : "";

  if (!spaceId) {
    throw new Error("spaceId is required");
  }
  if (!["accepted", "rejected"].includes(action)) {
    throw new Error("action must be accepted or rejected");
  }
  if (action === "rejected" && !rejectionReason) {
    throw new Error("rejectionReason is required when action is rejected");
  }

  const body = { spaceId, action };
  if (action === "rejected") {
    body.rejectionReason = rejectionReason;
  }

  return Axios.post("business/verification/admin/cin-pan/review", body);
};

export const updateSpaceStatus = async (input = {}) => {
  const spaceId = typeof input.spaceId === "string" ? input.spaceId.trim() : "";
  const status = typeof input.status === "string" ? input.status.trim() : "";

  if (!spaceId) {
    throw new Error("spaceId is required");
  }
  if (!["pending", "rejected", "verified"].includes(status)) {
    throw new Error("status must be pending, rejected, or verified");
  }

  return Axios.post("business/verification/admin/space/status", {
    spaceId,
    status,
  });
};
